import React from "react";
import { Link } from "react-router-dom";

const ChimneyName = ({ sleeve }) => (
  <Link to={`/sleeves/by/${sleeve.chim_dir}`}>
    <span className="chim-name">{sleeve.full_name} Chimney</span>
  </Link>
);

export default ChimneyName;
